exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Ri0LqI5IsstT7_MaSqcvP{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0}._2zsNE2f_5kMfPQY5rd7R0F{min-width:500px}html[dir] .A693HHp5I4e2hH5BDwxp9{margin:25px}html[dir] .ZJ5EeTxHY0QrDRnp68mDO{margin:10px 50px}", ""]);
// Exports
exports.locals = {
	"container": "_3Ri0LqI5IsstT7_MaSqcvP",
	"table": "_2zsNE2f_5kMfPQY5rd7R0F",
	"rightPanel": "A693HHp5I4e2hH5BDwxp9",
	"button": "ZJ5EeTxHY0QrDRnp68mDO"
};